"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGame = createGame;
exports.joinGame = joinGame;
const players_1 = require("../players");
const random_1 = require("../random");
const rules_1 = require("../rules");
function createGame(rules) {
    return {
        gameId: (0, random_1.rollGameId)(),
        rules,
        players: [null, null],
        gameState: {
            state: 'created',
        },
        history: [],
    };
}
function joinGame(model, user) {
    if (model.gameState.state !== 'created') {
        throw new Error('Game is not in created state');
    }
    if ((0, players_1.isGameFull)(model.players)) {
        throw new Error('Game is full');
    }
    if ((0, players_1.isUserInGame)(model.players, user)) {
        throw new Error('User is already in game');
    }
    const players = (0, players_1.addUserToPlayers)(model.players, user);
    const newModel = Object.assign(Object.assign({}, model), { players });
    if ((0, players_1.isGameFull)(newModel.players)) {
        return startGame(newModel);
    }
    return newModel;
}
function startGame(model) {
    if (model.gameState.state !== 'created') {
        throw new Error('Game is not in created state');
    }
    if (!(0, players_1.isGameFull)(model.players)) {
        throw new Error('Game is not full');
    }
    const rules = (0, rules_1.getRules)(model.rules);
    return Object.assign(Object.assign({}, model), { gameState: rules.getInitialGameState(), history: [] });
}
